import clsx from 'clsx';
import { FC, ReactElement } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

type LinkVariant = 'primary' | 'secondary' | 'neutral';
type LinkWeight = 'regular' | 'weak' | 'none';

interface StyleProps {
  className: string;
}

export interface LinkRendererProps {
  variant?: LinkVariant;
  weight?: LinkWeight;
  isDisabled?: boolean;
  external?: boolean;

  children(styleProps: StyleProps): ReactElement;
}

const useVariantStyles = makeStyles((theme: Theme) =>
  createStyles({
    neutral: {
      color: 'inherit',
    },
    secondary: {
      color: theme.palette.secondary.main,
    },
    primary: {
      color: theme.palette.primary.main,
    },
  }),
);

const useWeightStyles = makeStyles(
  {
    regular: {
      fontWeight: 'bold',
    },
    weak: {
      fontWeight: 'normal',
    },
    none: {},
  },
  { name: 'Link' },
);

const LinkRenderer: FC<LinkRendererProps> = ({
  children,
  variant = 'primary',
  weight = 'regular',
  isDisabled,
}) => {
  const variantClasses = useVariantStyles();
  const linkWeightClasses = useWeightStyles();

  const styleProps = {
    className: clsx(
      variantClasses[variant],
      linkWeightClasses[weight],
      'hover:underline',
      {
        'opacity-75 cursor-default': isDisabled,
      },
    ),
  };
  return children(styleProps);
};

export default LinkRenderer;
